/* eslint-disable no-use-before-define */
import { ajax  } from '../../twd/twd'

var lastAjaxAbort

var lastSign = ''
var lastHtml = ''
var lastTs = 0

export const getMarketCheckData = async ({
    askId,
    askPrice,
    askQuantity,
    highYieldInd,
    holdCusip,
    holdInvType,
}) => {
    try {
        if (lastAjaxAbort) lastAjaxAbort()

        let params = {
            cusip: holdCusip,
            askId: askId || '',
            invType: holdInvType,
            askQty: numberFrom(askQuantity, null),
            price: numberFrom(askPrice, null),
            highYield: highYieldInd || 'N',
            action: 'B',
            outputFormat: 'HTMLBW'
        }
        let sign = Object.values(params).join('')

        if (lastSign === sign && (Date.now() - lastTs)<60000) {
            return lastHtml
        }

        lastSign = ''
        lastTs = 0

        let {data, abort} = await ajax({
            url: '/esb/portfolio/marketcheckpopup',
            method: 'POST',
            type: 'text',
            params,
        })

        lastAjaxAbort = abort
        let html = formatHtml((await data) || '')
        lastAjaxAbort = null

        lastSign = sign
        lastHtml = html
        lastTs = Date.now()

        return html
    } catch(e) {
        return null
    }
}

const numberFrom = (a, b) => {
    if (isFinite(a)) a = parseFloat(a)
    return !isNaN(a) ? a : b
}

const formatHtml = (html) => {
    if (!html) return ''

    html = html.replace(
        '/styles/monarch/images/bd-',
        'resources/images/twd-')

    html = html.replace(
        /<span [^>]*>Go to MarketView<\/span>/,
        '')


    return html.replace(
        /<span [^>]*>View All<\/span>/g,
        '')
}